import actions from './actions'
import moment from 'moment';

const initState = {
    jornadas: [],
    personalDisponible: [],
    drawerOpen: false,
    action: null,
    day: null,
    turn: null
};


export default function appReducer(state = initState, action) {
    switch (action.type) {
        case actions.OPEN_DRAWER:
            return { ...state, drawerOpen: true, action: action.payload.action, day: action.payload.day, turn: action.payload.turn };
        case actions.CLOSE_DRAWER:
            return { ...state, drawerOpen: false, action: null, day: null, turn: null };
        case actions.SET_JORNADAS:
            return { ...state, jornadas: action.payload.jornadas };
        case actions.SET_PERSONAL_DISPONIBLE:
            return { ...state, personalDisponible: action.payload.personalDisponible };
        default:
            return state;
    }
}
